import getRows from '../utils/getRows'
import { useEffect } from 'react'

interface useInitProps {
  setRows: Function
  setDeleteEntryId: Function
  setShowModal: Function
  setShowOverlay: Function
  filter?: {} | null
  currentCustomer?: {} | null
}

const useInit = (props: useInitProps) => {
  useEffect(() => {
    //request server when the filter is on null (Filter component initializes the filter object)
    getRows({
      setDeleteEntryId: props.setDeleteEntryId,
      setShowModal: props.setShowModal,
    })
    .then((data: any) => {
      props.setRows(data)
      props.setShowOverlay(false)
    })
  }, [props.filter, props.currentCustomer])
}

export default useInit
